import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-06fcf68d")

_pushScopeId("data-v-06fcf68d")
const _hoisted_1 = { class: "login-and-out" }
const _hoisted_2 = {
  key: 0,
  class: "logout"
}
const _hoisted_3 = { style: {"color":"white","margin-right":"15px"} }
const _hoisted_4 = {
  key: 1,
  class: "login"
}
const _hoisted_5 = /*#__PURE__*/_createTextVNode("登录")
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "separator" }, " | ", -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode("注册")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.isLogin)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _createVNode("span", _hoisted_3, "欢迎，" + _toDisplayString(_ctx.userName), 1),
          _createVNode("button", {
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args))),
            style: {"color":"#ddd"}
          }, "注销")
        ]))
      : (_openBlock(), _createBlock("div", _hoisted_4, [
          _createVNode(_component_router_link, {
            class: "login-link",
            to: "/login"
          }, {
            default: _withId(() => [
              _hoisted_5
            ]),
            _: 1
          }),
          _hoisted_6,
          _createVNode(_component_router_link, {
            class: "login-link",
            to: "/register"
          }, {
            default: _withId(() => [
              _hoisted_7
            ]),
            _: 1
          })
        ]))
  ]))
})